import { AnswerOptions } from '@wui/jssip/lib/RTCSession'

import { useUserMediaStream } from '@/shared/composables/media-stream'

export const getAnswerOptions = async (audioEnabled: boolean, videoEnabled: boolean, useMediaStubs = false, ...extraHeaders: string[]): Promise<AnswerOptions> => {
  const options: AnswerOptions = {
    mediaConstraints: {
      audio: useMediaStubs ? true : audioEnabled,
      video: useMediaStubs ? true : videoEnabled,
    },
    rtcOfferConstraints: {
      offerToReceiveAudio: true,
      offerToReceiveVideo: true,
      iceRestart: false,
    },
    rtcAnswerConstraints: {
      offerToReceiveAudio: true,
      offerToReceiveVideo: true,
      iceRestart: false,
    },
    pcConfig: {
      bundlePolicy: 'max-bundle',
    },
    extraHeaders: [
      ...extraHeaders,
      `X-Satel-Params: MuteMyVideo=${!videoEnabled};MuteMyAudio=${!audioEnabled}`,
    ],
  }
  const mediaStream = await useUserMediaStream().getUserMedia(audioEnabled, videoEnabled, useMediaStubs)
  options.mediaStream = mediaStream

  return options
}
